import script from "./indexTable.vue?vue&type=script&setup=true&lang=js"
export * from "./indexTable.vue?vue&type=script&setup=true&lang=js"

import "./indexTable.vue?vue&type=style&index=0&id=e75f4e0c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e75f4e0c"]])

export default __exports__